<template>
  <!-- <div v-if = "td.length > 0" id="layout">
    <FLoader />
    <HeaderPartial />
    <div class="main-content">
      <div class="container mt-3">
        <router-view />
        <MyDialog />
      </div>
    </div>
    <FooterPartial />
  </div> -->
  <div v-if="user">
    <!-- <div v-if="isShowNewDesign">
      <router-view />
    </div> -->
    <!-- header + page fill exactly the screen (whatever the header's height), so short pages don't scroll -->
    <!-- fillScreen (Dashboard, Search): the page fills at least the screen, and a long list scrolls the whole page
         like the Work Order lists (rules in eval-figma.css) -->
    <div class="relative min-h-screen flex flex-col font-roboto" :class="{ fillScreen }">
      <div class="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-[#f5f5f5] via-[#fcfcfc] to-[#fefefe]"
        style="z-index: -9">
        <img src="../../assets/images/body-Bg.png" alt="Body Bg" class="w-full h-screen object-cover">
      </div>
      <FLoader />
      <!-- Silent login / SSO (Pro panel td link, mobile app) open single pages: no header, side menu or footer
           and no breadcrumb / search row (the page title card stays). -->
      <headerNew v-if="isFromMobile != 1 && !isEmbedded" />
      <!-- min-h-screen + flex column: the footer stays at the bottom while a page is still loading its data.
           Its height comes from the flex parent above (screen minus the header) -->
      <div
        class="flex-1 flex flex-col mobile:px-3 mobile:pt-28 laptop:pt-24 desktop:pt-16 largeDesktop:pt-20 largeDesktop:px-5 px-3 pb-4"
        :class="{ '!pt-[50px]': isFromMobile == 1 && !isEmbedded, '!pt-[20px] largeDesktop:!pl-3 laptop:container laptop:mx-auto': isEmbedded, fitScreenMain: fillScreen }">
        <proxyLogin v-if="isProxyLoggedIn" class="mb-[20px]" />
        <GlobaldashboardHead v-if="!isEmbedded" />
        <!-- {{ isCollapsed }} -->
        <WelcomeCard :heading="'Welcome, ' + (user ? user.user.full_name : '')"
          :text="'Let’s make today productive and achieve some great results'" />
        <div class="flex flex-grow items-start gap-5">
          <div class="flex items-start largeDesktop:gap-5 laptop:gap-4 mt-10 w-full transition duration-800" :class="{
            '!mt-3': $route.name === 'summary-detail' 
          }">
            <SidebarNavigation v-if="!noSideMenu"
              class="!w-auto transition duration-800 flex-shrink-0 mobile:hidden laptop:flex"
              @sidebar-collapse="handleSidebarCollapse" />
            <!-- <sidebar class="!w-auto transition duration-800 flex-shrink-0 mobile:hidden laptop:flex" /> -->

            <!-- Main Content -->
            <div class="flex-1 min-w-0 transition duration-1500" :class="{
              fitScreenContent: fillScreen,
              'w-[calc(100vw-320px)] mx-auto': !isCollapsed && !noSideMenu, // 100vw - 64 (16rem = 256px)
            }">
              <!-- <dashboard /> -->
              <BackToSearch />
              <BackToDetail />
              <router-view />
            </div>
          </div>
        </div>
        <FooterPartial v-if="!isEmbedded" />
      </div>
      <!-- <div class="main-content">
          <div class="container mt-3">
            <router-view />
            <MyDialog />
          </div>
        </div> -->
    </div>
    <MyDialog />
    <ConfirmDialog />
  </div>
</template>

<script>
import headerNew from "../../components/layouts/header/header_new.vue";
import GlobaldashboardHead from "../globaldashboardHead.vue";
import SidebarNavigation from "../sidebarNavigation.vue";
import WelcomeCard from "../welcomeCard.vue";
import FooterPartial from "./footer/FooterPartial";
import proxyLogin from "../partialComponent/proxyLogin.vue";
import BackToSearch from "../partialComponent/BackToSearch.vue";
import BackToDetail from "../partialComponent/BackToDetail.vue";
import { isSilentLogin } from "../../helpers/embedMode";
import sidebar from "../nest_components/omega_sidebar/sidebar.vue";
// import dashboard from "../../views/dashboard/dashboard.vue";

export default {
  name: "Layout",

  components: {
    headerNew,
    GlobaldashboardHead,
    WelcomeCard,
    SidebarNavigation,
    FooterPartial,
    proxyLogin,
    BackToSearch,
    BackToDetail,
    // sidebar
    // dashboard
  },

  data() {
    return {
      td: '',
      user: JSON.parse(localStorage.getItem('user')) ?? null,
      isCollapsed: false // or true, depending on your default state
    };
  },

  computed: {
    isFromMobile() {
      return this.$route.query.is_from_mobile ?? 0;
    },
    // Silent login (td) and SSO set isSilentLogin; re-read on every navigation
    isEmbedded() {
      return this.$route.fullPath && isSilentLogin();
    },
    // embedded pages and full-width flows (Create Replacement Quote: route meta hideSideMenu) have no side menu
    noSideMenu() {
      return this.isEmbedded || !!this.$route.meta.hideSideMenu;
    },
    // pages that fill at least the screen on laptop+; a long list scrolls the whole page
    fillScreen() {
      return ['dashboard', 'globalSearch'].includes(this.$route.name) && !this.isEmbedded && this.isFromMobile != 1;
    },
    isProxyLoggedIn() {
      return this.$route.fullPath && this.$helper.isProxyLoggedIn();
    },

  },
  mounted() { },

  methods: {
    handleSidebarCollapse(isCollapsed) {
      this.isCollapsed = isCollapsed;
    }
  }
};
</script>
